import React, { useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import InputWrapper from "../../citizen/AVPForms/layout/inputWrapper";
import { Table, TableContainer } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import ButtonWrapper from "../../citizen/AVPForms/components/Button";
import SortingAlphabatically from "../../citizen/AVPForms/reusableComponents/SortingAlphbatically";
import RemarksEditor from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/RemarksEditor";
const KhasraDetails = ({ callKhasraDetailsApi, updateKhasraDetails, formData, khasraRemarks, setKhasraRemarks, role }) => {
  const incomingKhasraDetails =
    Array.isArray(formData?.khasraDetails) && formData?.khasraDetails.some((item) => item.landUse)
      ? formData?.khasraDetails
      : formData?.descriptionOfLand?.khasraDetails || [];
  const [error, setError] = useState(false);
  console.log("logKhasraDetails", incomingKhasraDetails);

  const mappedKhasraDetails = incomingKhasraDetails.map((item) => ({
    villageName: item.village || item.villageName || "",
    tehsil: item.tehsil || "",
    khasraNumber: item.plotNo || item.khasraNumber || "",
    landUse: item.landUse || "",
    siteLandAddress: item?.siteLandAddress || "",
  }));
  const isAllowedRole = ["DRAFTSMAN", "Authorized_Officer"].includes(role);
  const isUpdateAllowed = !["APPROVED", "REJECTED", "MAKE_PAYMENT", "UPLOAD_DOC"].includes(formData?.status);

  const stripHtmlTags = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.innerText || tempDiv.textContent || ""; // Get the plain text
  };
  console.log("MAPPEDkHASRAdETAILS", mappedKhasraDetails);

  const { control, handleSubmit, watch } = useForm({
    defaultValues: {
      khasraDetails: mappedKhasraDetails.length > 0 ? mappedKhasraDetails : [{ villageName: "", khasraNumber: "", landUse: "", tehsil: "" }],
    },
  });
  const tenantId = Digit.ULBService.getStateId() || "up";
  // const watchTehsil = watch("descriptionOfLand.khasraDetails[0].tehsil");

  const { data: { BPA: { LandUseVillageMasterData: villagesData } = {} } = {}, isLoading: isVillagesLoading } = Digit.Hooks.obps.useMDMS(
    tenantId,
    "BPA",
    ["LandUseVillageMasterData"]
  );
  const filterTehsilData = (masterData, authority) => {
    console.log("filterTehsilDataCalled", masterData, authority);

    const result = masterData
      ?.find((item) => item.authorityName === authority)
      ?.tehsils?.map((item) => ({ name: item.tehsilName, label: item.tehsilName, value: item.tehsilName }));
    console.log("resultTehsil", result);
    return result || [];
  };
  const filterVillagesData = (masterData, authority, tehsil) => {
    console.log("villagesFilteredData", authority, tehsil);
    const result = tehsil
      ? masterData
          ?.find((item) => item?.authorityName === authority)
          ?.tehsils?.find((item) => item?.tehsilName === tehsil)
          ?.villages?.map((item) => ({
            name: item,
            label: item,
            value: item,
          }))
      : null;
    return result || [];
  };
  const tehsils = filterTehsilData(villagesData, "Lucknow Development Authority");
  // const villages = filterVillagesData(villagesData, "Lucknow Development Authority", watchTehsil);
  const { fields, append, remove } = useFieldArray({
    control,
    name: "khasraDetails",
  });

  const onSubmit = (data) => {
    const plainText = stripHtmlTags(khasraRemarks);
    if (plainText.trim().length === 0) {
      setError(true);
      return;
    } else {
      setError(false);
    }
    updateKhasraDetails(data.khasraDetails, khasraRemarks);
    if (!khasraRemarks) {
      setError(true);
    }
    if (khasraRemarks) {
      console.log("Submitted data:", data);
      callKhasraDetailsApi(data.khasraDetails, khasraRemarks);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <TableContainer className="table-container">
        <Table stickyHeader className="application-table" border="1" cellPadding="8">
          <colgroup>
            <col style={{ width: "60px" }} /> {/* Sr No. */}
            <col style={{ width: "180px" }} /> {/* Tehsil */}
            <col style={{ width: "180px" }} /> {/* Village */}
            <col style={{ width: "120px" }} /> {/* Khasra Number */}
            <col style={{ width: "120px" }} /> {/* Land Use */}
            <col style={{ width: "120px" }} /> {/* Site Address Land Address */}
            <col style={{ width: "80px" }} /> {/* Actions */}
          </colgroup>
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>
                Tehsil<span className="compulsoryField"> *</span>
              </th>
              <th>
                Village<span className="compulsoryField"> *</span>
              </th>
              <th>
                Khasra Number<span className="compulsoryField"> *</span>
              </th>
              <th>
                Land Use<span className="compulsoryField"> *</span>
              </th>
              <th>
                Site / Land Address<span className="compulsoryField"> *</span>
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {fields.map((field, index) => {
              // Watch tehsil for this row
              const tehsilValue = watch(`khasraDetails[${index}].tehsil`);
              const villagesForTehsil = filterVillagesData(villagesData, "Lucknow Development Authority", tehsilValue);
              return (
                <tr key={field.id}>
                  <td>{index + 1}</td>
                  <td style={{ minWidth: "180px" }}>
                    <InputWrapper
                      hasLabel={false}
                      control={control}
                      data={SortingAlphabatically(tehsils)}
                      placeholder="Select Tehsil"
                      width={"100%"}
                      name={`khasraDetails[${index}].tehsil`}
                      type="textInput"
                      disabled
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </td>
                  <td style={{ minWidth: "180px" }}>
                    <InputWrapper
                      hasLabel={false}
                      width={"100%"}
                      control={control}
                      data={SortingAlphabatically(villagesForTehsil)}
                      disabled
                      placeholder="Select Village"
                      // disabled={!isAllowedRole}
                      name={`khasraDetails[${index}].villageName`}
                      type="textInput"
                      maxLength={30}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </td>
                  <td style={{ minWidth: "120px" }}>
                    <InputWrapper
                      // label="Khasra Number"
                      hasLabel={false}
                      control={control}
                      placeholder="Enter khasra number"
                      name={`khasraDetails[${index}].khasraNumber`}
                      disabled
                      type="specialChar"
                      allowedChars=",-/"
                      width={"100%"}
                      maxLength={20}
                      mandatory
                      // disabled={!isAllowedRole}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </td>
                  <td style={{ minWidth: "120px" }}>
                    <InputWrapper
                      // label="Land Use"
                      hasLabel={false}
                      width={"100%"}
                      control={control}
                      placeholder="Enter land use"
                      name={`khasraDetails[${index}].landUse`}
                      type="textInput"
                      maxLength={400}
                      mandatory
                      // disabled={!isAllowedRole}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </td>
                  <td style={{ minWidth: "120px" }}>
                    <InputWrapper
                      // label="Land Use"
                      hasLabel={false}
                      width={"100%"}
                      control={control}
                      placeholder="Enter Site/Land Address"
                      name={`khasraDetails[${index}].siteLandAddress`}
                      type="textInput"
                      maxLength={400}
                      mandatory
                      // disabled={!isAllowedRole}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {index !== 0 && (
                      <button type="button" onClick={() => remove(index)}>
                        <DeleteIcon />
                      </button>
                    )}
                    {index === fields.length - 1 && (
                      <button
                        type="button"
                        onClick={() => {
                          const base =
                            mappedKhasraDetails.length > 0 ? { ...mappedKhasraDetails[0] } : { tehsil: "", villageName: "", khasraNumber: "" };
                          delete base.landUse; // remove landUse field
                          append({ ...base, landUse: "" }); // explicitly empty
                        }}
                        style={{ marginLeft: 8 }}
                      >
                        <AddIcon />
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </TableContainer>
      {<RemarksEditor setRemarks={setKhasraRemarks} remarks={khasraRemarks} error={error} setError={setError} title="Additional comments" />}
      {isUpdateAllowed && (
        <div style={{ display: "flex", justifyContent: "space-around", textAlign: "center", marginTop: "8px" }}>
          <ButtonWrapper
            variant="contained"
            color="success"
            size="medium"
            label="Save"
            type="submit"
            sx={{ backgroundColor: "#157CB3", marginRight: "4px" }}
          />
        </div>
      )}
    </form>
  );
};

export default KhasraDetails;
